import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.5",
      d: "m4.448 19.131.094-1.41-2.21-1.511a.3.3 0 0 1-.042-.46l.82-.82a.3.3 0 0 1 .268-.083l3.253.607 4.494-4.877L1.79 5.825a.5.5 0 0 1-.127-.8l.848-.847a.5.5 0 0 1 .44-.139l12.224 2.14 3.202-3.474a4.81 4.81 0 0 1 3.973-1.532.65.65 0 0 1 .588.589 4.81 4.81 0 0 1-1.53 3.973l-3.476 3.201 2.205 12.29a.5.5 0 0 1-.138.442l-.848.848a.5.5 0 0 1-.798-.126l-4.818-9.403-4.878 4.494.545 3.19a.3.3 0 0 1-.084.262l-.82.821a.3.3 0 0 1-.461-.044L6.39 19.57l-1.41.093a.5.5 0 0 1-.532-.532Z"
    }, null, -1)
  ]))]))
}
export default { render: render }